import Constants from '../constants/Constants'

export const http = (state = { httpStatus: '', text: '', error: undefined, upload: false }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.HTTP.LOADING:
      return Object.assign({}, state,
        { httpStatus: Constants.ActionsConstants.HTTP.LOADING, text: action.text, error: undefined })
    case Constants.ActionsConstants.HTTP.UPLOADING:
      return Object.assign({}, state,
        { httpStatus: Constants.ActionsConstants.HTTP.LOADING, upload: true })
    case Constants.ActionsConstants.HTTP.UPLOADINGEND:
      return Object.assign({}, state,
        { httpStatus: '', upload: false })
    case Constants.ActionsConstants.HTTP.LOADED:
      return Object.assign({}, state,
        { httpStatus: Constants.ActionsConstants.HTTP.LOADED, text: action.text, error: undefined })
    case Constants.ActionsConstants.HTTP.ERROR:
      return Object.assign({}, state,
        { httpStatus: Constants.ActionsConstants.HTTP.ERROR, text: action.text, error: undefined })
    case Constants.ActionsConstants.HTTP.CLEAR_STATUS:
      return Object.assign({}, state,
        { httpStatus: '', text: '', error: '' })
    default:
      return state
  }
}

export const loading = (what) => {
  return {
    type: Constants.ActionsConstants.HTTP.LOADING,
    text: what,
  }
}

export const uploading = (what) => {
  return {
    type: Constants.ActionsConstants.HTTP.UPLOADING,
    text: '',
  }
}

export const endUploading = (what) => {
  return {
    type: Constants.ActionsConstants.HTTP.UPLOADINGEND,
    text: '',
  }
}

export const loaded = (what) => {
  return {
    type: Constants.ActionsConstants.HTTP.LOADED,
    text: what,
  }
}

export const errorLoading = (error) => {
  return {
    type: Constants.ActionsConstants.HTTP.ERROR,
    text: error,
  }
}

export const clearStatus = () => {
  return {
    type: Constants.ActionsConstants.HTTP.CLEAR_STATUS,
  }
}

export function clearHttpStatus(dispatch) {
  function cHS() {
    dispatch(clearStatus())
  }

  return {
    clear: cHS,
  }
}

export function responseHandler(response) {
  if (!response.ok) {
    const contentType = response.headers.get('content-type')
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return response.json().then((json) => {
        let error = {
          status: response.status,
          text: json.message || response.statusText,
        }
        throw JSON.stringify(error)
      })
    } else {
      return response.text().then(text => {
        let error = {
          status: response.status,
          text: text || response.statusText,
        }
        throw JSON.stringify(error)
      })
    }
  }

  return response
}

export function tokenInterceptor(response) {
  if (response.headers.get('Authtoken')) {
    Constants.UrlsConstants.header.authtoken = response.headers.get('Authtoken')
    Constants.UrlsConstants.headerFormData.authtoken = response.headers.get('Authtoken')
    Constants.UrlsConstants.authTokenParam = '?authtoken=' + response.headers.get('Authtoken')
  }
  if (response.headers.get('Refreshtoken')) {
    Constants.UrlsConstants.header.refreshtoken = response.headers.get('Refreshtoken')
    Constants.UrlsConstants.headerFormData.refreshtoken = response.headers.get('Refreshtoken')
  }
}

export function errorGetStatus(error) {
  let status
  try {
    status = JSON.parse(error).status
  } catch (err) {
    status = 500
  }
  return status
}

export function errorGetText(error) {
  let text
  try {
    text = JSON.parse(error).text
  } catch (err) {
    text = "An error occured"
  }
  return text
}

export function progress(stream, result, total = 0) {
  while (stream.state === 'readable') {
    var data = stream.read()
    total += data.byteLength
    console.log('received ' + data.byteLength + ' bytes (' + total + ' bytes in total).')
  }
  if (stream.state === 'waiting') {
    stream.ready.then(() => progress(stream, result, total))
  }
  return result
}
